import { useEffect, useState } from "react";

const useTrim = (word,wordLimit)=>{
    const [trimed,setTrimed] = useState()
    useEffect(()=>{
        const trimWord = ()=>{
            const wordArr = word.split('');
            let limit = wordLimit
            if(window.innerWidth>=1024){
                limit = 25
            }
            if(wordArr.length-1<limit){
                setTrimed(word)
                return 
            }
            const trimArr = wordArr.map((letter,index)=>{
                if(index<limit){
                    return letter
                }
                return null
            })
            trimArr.push('...');
            setTrimed(trimArr.join(''))
        }
        trimWord();
    },[word,wordLimit])
    return {trimed};

}

export default useTrim;